class AutoExpandTextarea {
	/**
	 *
	 * @param {string} selector
	 */
	constructor(selector) {
		/**
		 *
		 * @type {NodeListOf<HTMLTextAreaElement>}
		 */
		const elements = document.querySelectorAll(selector);

		elements.forEach((item) => {
			item.setAttribute("rows", "3");
			item.addEventListener("input", this.onInput.bind(this));
		});
	}

	/**
	 *
	 * @param {Event} e
	 */
	onInput(e) {
		/**
		 *
		 * @type {HTMLTextAreaElement}
		 */
		const field = e.currentTarget;
		// Reset field height
		field.style.height = "inherit";

		// Get the computed styles for the element
		const computed = window.getComputedStyle(field);

		// Calculate the height
		const height =
			parseInt(computed.getPropertyValue("border-top-width"), 10) +
			parseInt(computed.getPropertyValue("padding-top"), 10) +
			field.scrollHeight +
			parseInt(computed.getPropertyValue("padding-bottom"), 10) +
			parseInt(computed.getPropertyValue("border-bottom-width"), 10);

		field.style.height = height + "px";
	}
}

export default AutoExpandTextarea;
